import React from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { useLanguage } from '../context/LanguageContext';

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [prefixer, rtlPlugin] });
const cacheLtr = createCache({ key: 'muiltr', stylisPlugins: [prefixer] });

const DirectionCacheProvider = ({ children }) => {
    const { isRtl } = useLanguage();
    return (
        <CacheProvider value={isRtl ? cacheRtl : cacheLtr}>
            {children}
        </CacheProvider>
    );
};

export default DirectionCacheProvider;
